var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIcStep2 = function SvgIcStep2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.1 10.75c0-.6.53-1.15 1.267-1.15.736 0 1.266.55 1.266 1.15 0 .193-.021.307-.06.403-.04.096-.117.217-.291.391l-3.194 3.02A.6.6 0 0 0 10.5 15.6h4a.6.6 0 1 0 0-1.2h-2.492l2.104-1.99.011-.01c.25-.248.438-.5.558-.789.12-.291.152-.577.152-.861 0-1.334-1.141-2.35-2.466-2.35C11.04 8.4 9.9 9.416 9.9 10.75a.6.6 0 1 0 1.2 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.5 12a8 8 0 1 1-16 0 8 8 0 0 1 16 0Zm-1.2 0a6.8 6.8 0 1 1-13.6 0 6.8 6.8 0 0 1 13.6 0Z"
  }))));
};
export default SvgIcStep2;